import { useSelector } from 'react-redux';
import type { RootState } from '../store/redux/store/store';
import type { ComplianceCountry } from '../models/general';

export const useComplianceCountry = (): ComplianceCountry => {
  const company = useSelector((s: RootState) => s.user.company);
  return (company?.complianceCountry ?? 'None') as ComplianceCountry;
};
